export const env = {
  USE_MOCKS: process.env.NEXT_PUBLIC_USE_MOCKS === 'true',
  API_URL: process.env.NEXT_PUBLIC_API_URL,
  API_KEY: process.env.NEXT_PUBLIC_API_KEY,
  STRAPI_WEBHOOK_SECRET: process.env.STRAPI_WEBHOOK_SECRET,
  SITE_URL: process.env.NEXT_PUBLIC_SITE_URL,
  RD_STATION_URL_TOKEN: process.env.NEXT_PUBLIC_RD_STATION_URL_TOKEN,
  VERCEL_WEBHOOK_URL: process.env.VERCEL_WEBHOOK_URL,
}
